import { mapProps } from 'recompose'
import CommunicationPreferencesView from './CommunicationPreferencesView'
import { appointment } from './helpers'

const withViewData = mapProps(({ appointmentReminder, savingAndDiscounts, ...props }) => ({
  ...props,
  reminders: appointment(appointmentReminder),
  promotions: appointment(savingAndDiscounts)
}))

export default withViewData(CommunicationPreferencesView)
